import { render } from "./z-checkbox.svg.js?vue&type=template&id=391d1a8b!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??clonedRuleSet-12.use[0]!../../../../../node_modules/vue-svg-loader-2/index.js??clonedRuleSet-12.use[1]!./z-checkbox.svg?vue&type=template&id=391d1a8b"
const script = {  }

import exportComponent from "../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__